@use '@/scss/underscore' as _;

.roleScopesTransfer {
  height: 360px;
}
